module.exports = __webpack_public_path__ + "img/synclounge.bcdff3df.svg";